<script setup>
import { ref } from 'vue'
import axios from 'axios'
import cookieHelper from '../cookie'
import {useFormSubmit} from '../../composables/useFormSubmit'
import useGlobalStore from '../../store/globalStore'

const { blogDownloadForm, closeModal } = useFormSubmit()

const globalStore = useGlobalStore()
const resourceElement = ref(false)
const controls = ref([
  '<i class=\'icon icon--arrow-left\'></i>',
  '<i class=\'icon icon--arrow-right\'></i>'
])
const heading = ref('Download')
const subHeader = ref('')
const buttonName = ref('Download')
const tagId = ref(0)
const listId = ref(0)
const showMoreSteps = ref([])

const toggleModal = (modalName, showFooter) => {
  globalStore.setModal(
    {
      name: modalName,
      showFooter: showFooter,
    }
  )
};

const checkResourceCentreAccess = (
  event,
  headerVal,
  subHeaderVal,
  buttonNameVal,
  tagIdVal,
  trackFormName = '',
  listIdVal = 0
) => {
  let email = cookieHelper.getCookie('resource-centre-email');

  if (!email) {
    heading.value = headerVal
    subHeader.value = subHeaderVal
    buttonName.value = buttonNameVal
    tagId.value = tagIdVal
    listId.value = listIdVal
    resourceElement.value = event.target
    event.preventDefault()

    globalStore.setModal(
      {
        name: 'resourceCentreModal',
        showFooter: true,
      }
    )

    return false
  }

  axios.post('/rc-access-grant', {'email': email, 'tagId': tagId, 'listId': listId}).then(function (response) {})

  if (trackFormName) {
    window.dataLayer = window.dataLayer || []
    window.dataLayer.push({
      'event': 'database opt in',
      'formName': trackFormName
    });
  }

  return true
}

const showMoreStepItems = (step) => {
  showMoreSteps.value.push(step)
}

const isShowMoreStepItemOpen = (step) => {
  return showMoreSteps.value.indexOf(step) !== -1
}

const hideMoreStepItems = (step) => {
  showMoreSteps.value.splice(showMoreSteps.value.indexOf(step), 1)
}

const mounted = () => {
  // if (refs.tinySliderFeatured) {
  //   const slideCount = parseInt(refs.tinySliderFeatured.slider.getInfo().slideCount, 10);
  //   localStorage.setItem('premiumVillagesCount', '0');
  //   localStorage.removeItem('premiumVillagesIndex');
  //   if (slideCount <= 3) {
  //     window.addEventListener('scroll', handleScroll);
  //   } else {
  //     refs.tinySliderFeatured.slider.events.on('indexChanged', tinyIndexChange);
  //   }
  // }
};

</script>
<template>
  <div>
    <slot
      name="content"
      :blogDownloadForm="blogDownloadForm"
      :toggleModal="toggleModal"
      :showMoreStepItems="showMoreStepItems"
      :isShowMoreStepItemOpen="isShowMoreStepItemOpen"
      :hideMoreStepItems="hideMoreStepItems"
      :heading="heading"
      :subHeader="subHeader"
      :checkResourceCentreAccess="checkResourceCentreAccess"
      :buttonName="buttonName"
      :tagId:="tagId"
      :resourceElement="resourceElement"
      :globalStore="globalStore"
      :closeModal="closeModal"
    ></slot>
  </div>
</template>
